import { FormControl, FormControlLabel, FormLabel, makeStyles, Radio, RadioGroup as MuiRadioGroup, useTheme } from "@material-ui/core";
import React from "react";
const useStyles = makeStyles((theme) => ({
    formControlLabelRoot: {
        margin: "0"
    },
    radioRoot: {
        flex: 1,
        paddingTop: theme.spacing(0),
        paddingRight: theme.spacing(0),
        paddingLeft: theme.spacing(0),
        paddingBottom: theme.spacing(0),
        marginBottom: theme.spacing(2),
        "&:hover": {
            backgroundColor: "transparent !important"
        }
    }
}));
const iconProps = (option) => {
    const props = {};
    if (option.component) {
        props.icon = option.component;
    }
    if (option.checkedComponent) {
        props.checkedIcon = option.checkedComponent;
    }
    return props;
};
export const RadioGroup = ({ row = false, options, formLabel, defaultValue, name, onChange }) => {
    const classes = useStyles();
    const theme = useTheme();
    return (React.createElement(FormControl, { fullWidth: true, component: "fieldset" },
        formLabel && React.createElement(FormLabel, { component: "legend" }, formLabel),
        React.createElement(MuiRadioGroup, { row: row, name: name, defaultValue: defaultValue, "aria-label": formLabel ? formLabel.toLowerCase() : undefined, onChange: (_e, value) => onChange(value) }, options.map((option) => (React.createElement(FormControlLabel, { key: option.value, label: option.label, value: option.value, classes: { root: classes.formControlLabelRoot }, control: React.createElement(Radio, Object.assign({ disableRipple: true, classes: {
                    root: classes.radioRoot,
                    checked: classes.radioRoot
                } }, iconProps(option))) }))))));
};
//# sourceMappingURL=RadioGroup.js.map